<template>
  <div id="app" class="">
    <!--    <Header/>-->
    <!-- <PhfSlide/> -->
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
  // import Header from './components/Header.vue'
  // import PhfSlide from './components/PhfSlide.vue'


  export default {
    name: 'App',
    components: {
      // Header,
      // PhfSlide
    },
  }
</script>

<style lang="scss">
  @import "./assets/styles/custom.scss";
</style>

